import { gql } from "@apollo/client";

const SALES_FOR_CUSTOMER = gql`
  query salesForCustomer {
    sales {
      __typename
      ... on Sale {
        sale_status
        operation_date
        payment_total
        address {
          street_name
          street_number
          floor
          department
        }
        sale_product {
          unitary_total
          quantity
          product {
            id
            name
            url_image
          }
        }
        shipment {
          id
          shipment_date
        }
      }
    }
  }
`;

const SALES_ADMIN = gql`
  query salesAdmin {
    salesAdmin {
      __typename
      ... on Sale {
        id
        operation_date
        payment_total
        address {
          street_name
          street_number
          floor
          department
        }
        sale_product {
          unitary_total
          quantity
          product {
            id
            name
            url_image
          }
        }
        user {
          firstname
          lastname
          phone
        }
        shipment {
          id
          shipment_date
        }
        sale_status
      }
    }
  }
`;
export { SALES_FOR_CUSTOMER, SALES_ADMIN };
